import styled from "styled-components";
import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";

export const Container = styled.div<{ isTopPositioned: boolean }>(({ theme, isTopPositioned }) => ({
    backgroundColor: theme.colors[theme.colorMode].background_Primary,
    borderRadius: theme.cornerRadius.medium,
    padding: theme.spacing.small,
    margin: theme.spacing.medium,
    marginTop: isTopPositioned ? 0 : theme.spacing.medium,
    marginBottom: isTopPositioned ? theme.spacing.medium : 0,
}));

export const HeaderText = styled(Text)(({ theme }) => ({
    marginBottom: theme.spacing.xSmall,
    marginLeft: theme.spacing.xxSmall,
}));

export const PlansContainer = styled.div(({ theme }) => ({
    display: "flex",
    gap: theme.spacing.xSmall,
}));
